module.exports = __webpack_public_path__ + "img/4.6f083e88.jpg";